<div class="container max-width">
  <div
    class="top"
    [class.active]="infoVisible"
    (click)="infoVisible = !infoVisible">
    <div class="info">
      <mat-icon>info</mat-icon>
      <p class="bold">{{ 'equity.country-info' | translate }}</p>
    </div>
    <mat-icon
      class="arrow"
      [class.rotate]="!infoVisible">
      keyboard_arrow_up
    </mat-icon>
  </div>
  <div
    class="bottom"
    [class.hidden]="!infoVisible">
    <p>{{ data?.content?.text }}</p>
    <br />
    <p class="bold">{{ data?.content?.excludedCountries?.join(', ') }}</p>
  </div>
</div>
